var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-scroller"},[_c('div',{staticClass:"icon-scroller-track"},_vm._l((_vm.icons),function(icon,index){return _c('div',{key:`is-${index}`,staticClass:"icon",class:{ selected: icon === _vm.key },on:{"click":function($event){return _vm.selectIcon(icon)}}},[_c('i',{class:icon})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }